// this is the api response for post request to orders endpoint i.e. order creation

import { IOrderDetailsApiDto } from '../api.types'
import { EOrderStatusName } from '../../orderStatus'

export const postOrderApiRespMock: IOrderDetailsApiDto = {
    amount_btc: 0,
    amount_eur: 0,
    amount_quote_fee: 0,
    amount_usd: 0,
    display_refund_address: false,
    price: { rate: 0, rate_btc: 0, rate_eur: 0, rate_usd: 0 },
    refund_address: null,

    amount_base: '14.11746066',
    is_default_rule: true,
    unique_reference: 'OKCCC6',
    amount_quote: '0.10000000',
    pair: {
        name: 'XMRBTC',
        base: {
            code: 'XMR',
            name: 'monero',
            min_confirmations: 10,
            is_crypto: true,
            minimal_amount: '0.10000000',
            maximal_amount: '7200.00000000',
            is_base_of_enabled_pair: true,
            is_quote_of_enabled_pair: true,
            has_enabled_pairs: true,
            is_base_of_enabled_pair_for_test: true,
            is_quote_of_enabled_pair_for_test: true,
            has_enabled_pairs_for_test: true,
            withdrawal_fee: '0.01500000',
            extra_id: null,
        },
        quote: {
            code: 'BTC',
            name: 'bitcoin',
            min_confirmations: 2,
            is_crypto: true,
            minimal_amount: '0.00100000',
            maximal_amount: '100.00000000',
            is_base_of_enabled_pair: true,
            is_quote_of_enabled_pair: true,
            has_enabled_pairs: true,
            is_base_of_enabled_pair_for_test: true,
            is_quote_of_enabled_pair_for_test: true,
            has_enabled_pairs_for_test: true,
            withdrawal_fee: '0.00050000',
            extra_id: null,
        },
        fee_ask: 0.04,
        fee_bid: 0.04,
    },
    withdraw_address: null,
    deposit_address: {
        type: 'D',
        name: '',
        address: '3LjcyARtRK7DvTmTFHfJxQp4j7ACXFgqap',
        currency_code: 'BTC',
        destination_tag: null,
        extra_id: null,
        memo: null,
    },
    created_on: '2020-12-23T09:50:06.907697Z',
    from_default_rule: false,
    payment_window: 15,
    payment_deadline: '2020-12-23T10:05:06.907697Z',
    kyc_deadline: null,
    status_name: [[11, EOrderStatusName.INITIAL]],
    transactions: [],
    referral_code: [
        {
            code: 'RDMGRNCOH8V',
            created_on: '2020-12-02T13:01:33.858980Z',
            modified_on: '2020-12-02T13:01:33.859003Z',
        },
    ],
    withdrawal_fee: 0.015,
    withdrawal_fee_quote: 0.00010611165,
    user_provided_amount: 1,
    payment_url: null,
    token: null,
}
